export const DEFAULT_ROWS_PER_PAGE = 10;
export const DEFAULT_DEBOUNCE_DELAY = 750;
